import React, { useState, useEffect } from "react";
import cn from "classnames";
import { SelectItemProps, SelectButtonProps } from "components/UI/dropdowns/DropdownSelect";
import { Option } from "components/UI/form/Select";

import styles from "./Dropdown.module.scss";
import { useDropdown } from "./dropdownHooks";

type DropdownProps = {
  ItemComponent: React.FC<SelectItemProps>;
  ButtonComponent: React.FC<SelectButtonProps>;
  buttonProps: SelectButtonProps;
  itemProps: SelectItemProps;
  items: Option[];
  className?: string;
};

export const Dropdown = ({
  ItemComponent,
  ButtonComponent,
  buttonProps,
  itemProps,
  items,
  className,
}: DropdownProps) => {
  const [dropdownItems, setDropdownItems] = useState<Option[]>(items);

  const { open, below, onBtnClick, dropdownBtn, dropdownBody, closeDropdown } = useDropdown();

  useEffect(() => {
    setDropdownItems(items);
  }, [items]);

  return (
    <div
      className={cn(styles.dropdownResponsive, className, {
        [styles.dropdownResponsiveOpen]: open,
      })}
    >
      <div ref={dropdownBtn}>
        <ButtonComponent {...buttonProps} onClick={onBtnClick} items={dropdownItems} />
      </div>
      <div
        ref={dropdownBody}
        className={cn(styles.itemsWrap, {
          [styles.itemsWrapOpen]: open,
          [styles.itemsWrapOpenBelow]: open && below,
          [styles.itemsWrapOpenAbove]: open && !below,
        })}
      >
        <ul className={styles.itemsList}>
          {dropdownItems.map((item, i) => (
            <li key={i} className={styles.item}>
              <ItemComponent {...itemProps} item={item} onClick={() => itemProps.onClick(closeDropdown)} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
